import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { config } from '../../../../configuration';
import { ServerResponse } from '../utils/server-response';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

@Injectable()
export class AuthenticationService {
  private _accountApiURL = `${config.apiUrl}/user/login`;
  private _headers = new Headers({ 'Content-Type': 'application/json' });
  private _options = new RequestOptions({ headers: this._headers });
  constructor(private _http: Http, private router: Router) { }

  logIn(username: string, pass: string, remember: boolean): Observable<any> {

    let bodyString = JSON.stringify({ username: username, password: pass });
    let options = new RequestOptions({ headers: this._headers });
    return this._http.post(this._accountApiURL, bodyString, options)
      .map((res: Response) => {
        let userInfo = res.json().data;
        if (res.json().data) {
          localStorage.setItem('currentUser', JSON.stringify(userInfo));
          return { result: true, error: "" };
        }
      })
      .catch(this.handleError);
  }

  getToken() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  checkUser() {
let userInfo = JSON.parse(localStorage.getItem('currentUser'));
    if(!userInfo)
        this.router.navigate(['/sign-in']);

    let headers = new Headers({
      'authorization': 'Bearer ' + userInfo.token,
      'atoken': userInfo.atoken
    });
    let options = new RequestOptions({ headers: headers });
    return this._http.get(`${config.apiUrl}/user/check`, options)
      .map((response: Response) => {
        return <ServerResponse>response.json()
      })
      .catch(this.handleError);
  }

  logOut() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['/sign-in']);
    return true;
  }

  private handleError(error: Response) {
    return Observable.throw(error.json().error);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/authentication.service.ts